/**
 * Strips null bytes (\u0000) from a string returned by the calc server.
 * The calc server can embed null terminators in JSON strings; JSON.parse will
 * reject them, so we strip them before parsing.
 *
 * @param {string} aStr
 * @returns {string}
 */
export const trimNull = aStr => {
  if (!aStr || aStr === '') return aStr;
  return aStr.replaceAll('\u0000', '');
};
